import React from 'react';
import ReactQuill from 'react-quill-new';

type QuillEditorLike = {
  getText: () => string;
};

type MyEditorProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> & {
  value: string;
  readOnly?: boolean;
  disableToolbar?: boolean;
  width?: React.CSSProperties['maxWidth'];
  onTextChange?: (text: string) => void;
  onChange?: (value: string) => void;
  noImage?: boolean;
  uid?: string | number;
};

const CustomToolbar = ({ uid }) => (
  <div id={`toolbar${uid}`}>
    <select className="ql-size" defaultValue="medium">
      <option value="small">Small</option>
      <option value="medium">Medium</option>
      <option value="large">Large</option>
      <option value="huge">Huge</option>
    </select>
    <button className="ql-bold"></button>
    <button className="ql-italic"></button>
    <select className="ql-color">
      <option value="red"></option>
      <option value="green"></option>
      <option value="blue"></option>
      <option value="orange"></option>
      <option value="violet"></option>
      <option value="#d0d1d2"></option>
      <option></option>
    </select>
    <select className="ql-background"></select>
    <button className="ql-link"></button>
    <button className="ql-image"></button>
  </div>
);
const SimpleToolbar = ({ uid }) => (
  <div id={`toolbar${uid}`}>
    <select className="ql-size" defaultValue="medium">
      <option value="small">Small</option>
      <option value="medium">Medium</option>
      <option value="large">Large</option>
      <option value="huge">Huge</option>
    </select>
    <button className="ql-bold"></button>
    <button className="ql-italic"></button>
    <select className="ql-color">
      <option value="red"></option>
      <option value="green"></option>
      <option value="blue"></option>
      <option value="orange"></option>
      <option value="violet"></option>
      <option value="#d0d1d2"></option>
      <option></option>
    </select>

  </div>
);

const BlankToolbar = ({ uid }) => (
  <div id={`toolbar${uid}`} style={{ height: 0, borderWidth: 0 }}></div>
);

function MyEditor({
  value,
  readOnly,
  disableToolbar,
  width,
  onTextChange,
  onChange,
  noImage = false,
  uid = "",
  style,
  ...containerProps
}: MyEditorProps) {
  const modules = {
    toolbar: {
      container: `#toolbar${uid ?? ""}`,
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "list",
    "align",
    "color",
    "background",
    "image",
  ];

  const handleText = (value: string, editor: QuillEditorLike) => {
    const textvalue = editor.getText();
    onTextChange?.(textvalue);
    onChange?.(value);
  };

  const mergedStyle: React.CSSProperties = {
    ...style,
    maxWidth: width ?? style?.maxWidth,
  };

  return (
    <div {...containerProps} style={mergedStyle}>
      {disableToolbar ? <BlankToolbar uid={uid ?? ""} /> : (noImage) ? <SimpleToolbar uid={uid ?? ""} /> : <CustomToolbar uid={uid ?? ""} />}
      <ReactQuill
        style={{ width: "100%", borderWidth: 0 }}
        modules={modules}
        formats={formats}
        value={value}
        onChange={(value: string, _delta: unknown, _source: unknown, editor: QuillEditorLike) => {
          handleText(value, editor);
        }}
        readOnly={readOnly}
      />
    </div>
  );
}

export default MyEditor;
